// src/quiz/gre-mock6/index.js
// GRE Mock 6 — props for the shared Gre_verbal / Gre_quantitative /
// Gre_analytical components. Test names end in "Mock 6" so the profile
// keeps these results apart from the other mocks.
import verbalQuestions from "./verbalData";
import { section1Questions, section2Questions } from "./quantitativeData";

export const greMock6 = {
  verbal: {
    questions: verbalQuestions,
    testName: "GRE Verbal Reasoning Mock 6",
    title: "GRE Verbal Reasoning — Mock 6",
  },
  quantitative: {
    section1: section1Questions,
    section2: section2Questions,
    testName: "GRE Quantitative Reasoning Mock 6",
    title: "GRE Quantitative Reasoning — Mock 6",
  },
  analytical: {
    testName: "GRE Analytical Writing Mock 6",
    title: "GRE Analytical — Mock 6",
    prompt:
      "\"A nation's greatness is better measured by the questions its citizens are free to ask than by the answers its leaders provide.\"",
    directions:
      "Write a response in which you discuss the extent to which you agree or disagree with the claim. In developing and supporting your position, be sure to address the most compelling reasons and/or examples that could be used to challenge your position.",
    topicKeywords: [
      "nation", "great", "question", "citizen", "free", "leader",
      "answer", "speech", "democra", "inquir", "power", "measure",
    ],
  },
};
